import React from "react";
import { useTranslation } from "react-i18next";
import { status as statusMock, Status } from "@planzone/dto";
import { ColorPickerIcon } from "./colorPickerIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function StatusCreationForm({ submit, displayColorPickerCreation }: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = React.useState(statusMock);

  return (
    <div className={styles.form}>
      <div>
        <div
          className={styles.iconBox}
          onClick={(e) => {
            e.stopPropagation();
            displayColorPickerCreation(e.clientY, status, setStatus);
          }}
        >
          {status.color ? (
            <div
              className={styles.icon}
              style={{ backgroundColor: status.color }}
            />
          ) : (
            <ColorPickerIcon className={styles.icon} />
          )}
        </div>
        <input
          className={styles.input}
          value={status.label}
          placeholder={t("statusCreationForm.namePlaceholder")}
          onChange={({ target }) =>
            setStatus({
              ...status,
              label: target.value,
            })
          }
          onKeyUp={({ key }) => key === "Enter" && submit(status)}
          autoFocus
        />
      </div>
      <div>
        <input
          className={styles.completion}
          value={status.percentComplete}
          type="number"
          placeholder={"%"}
          onChange={({ target }) => {
            if (target.value === "") {
              setStatus({ ...status, percentComplete: undefined });
            } else if (
              parseInt(target.value) >= 0 &&
              parseInt(target.value) <= 100
            ) {
              setStatus({
                ...status,
                percentComplete: parseInt(target.value),
              });
            }
          }}
          onKeyUp={({ key }) => key === "Enter" && submit(status)}
        />
      </div>
      <div>
        <button className={styles.button} onClick={() => submit(status)}>
          {t("statusCreationForm.submit")}
        </button>
      </div>
    </div>
  );
}

export { StatusCreationForm };
